import { SearchParameters } from "./SearchParameters";

export class ContractSearchParameters {
    searchParameters: SearchParameters = new SearchParameters();
    supplierID: number = 0;
    brandID: number = 0;
    productGroupID: number = 0;
}